import { render, staticRenderFns } from "./MixedAgingaccountsPay.vue?vue&type=template&id=70365738&scoped=true"
import script from "./MixedAgingaccountsPay.vue?vue&type=script&lang=js"
export * from "./MixedAgingaccountsPay.vue?vue&type=script&lang=js"
import style0 from "./MixedAgingaccountsPay.vue?vue&type=style&index=0&id=70365738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70365738",
  null
  
)

export default component.exports